<template>
  <div>
    <v-row justify="center">
      <v-dialog class="modal_medium" v-model="visible" persistent>
        <v-card>
          <v-form
            ref="form"
            v-model="valid"
            method="post"
            enctype="multipart/form-data"
            lazy-validation
          >
            <v-card-title>
              <span class="headl">NUEVO PERFIL</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="nuid"
                      v-model="form.nuid"
                      :rules="nameRules"
                      label="NUI"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="IDcard"
                      v-model="form.IDcard"
                      :rules="nameRules"
                      label="Cedula"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="firtsName"
                      v-model="form.firtsName"
                      :rules="nameRules"
                      label="Primero Nombre"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="secondName"
                      v-model="form.secondName"
                      label="Segundo Nombre"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="firtsSurName"
                      v-model="form.firtsSurName"
                      :rules="nameRules"
                      label="Primero Apellido"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="secondSurName"
                      v-model="form.secondSurName"
                      label="Segundo Apellido"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-combobox
                      ref="company"
                      v-model="form.company"
                      :items="itemsCompany"
                      :search-input.sync="search"
                      item-value="_id"
                      item-text="name"
                      label="Empresas"
                      placeholder="Digite el nombre de la empresa"
                      :disabled="isMaster == 0"
                      clearable
                      :rules="fieldRules"
                    ></v-combobox>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-select
                      ref="activate"
                      v-model="form.activate"
                      :items="[
                        { id: '1', name: 'Activo' },
                        { id: '0', name: 'Inactivo' },
                      ]"
                      item-value="id"
                      item-text="name"
                      label="Estado"
                      :rules="fieldRules"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="codeDep"
                      v-model="form.codeDep"
                      :rules="nameRules"
                      label="Departamento"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="codeMun"
                      v-model="form.codeMun"
                      :rules="nameRules"
                      label="Ciudad"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      ref="address"
                      v-model="form.address"
                      :rules="nameRules"
                      label="Dirección"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="ctn_btn_shop">
                <v-btn large text @click.stop="show = false">Cerrar</v-btn>
                <v-btn
                  :disabled="!valid"
                  depressed
                  large
                  color="primary"
                  @click="validate"
                  >GUARDAR</v-btn
                >
              </div>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ProfileNewComp",
  components: {},
  props: ["visible"],
  data() {
    return {
      form: {
        firtsName: null,
        secondName: null,
        firtsSurName: null,
        secondSurName: null,
        nuid: null,
        IDcard: null,
        codeDep: null,
        codeMun: null,
        address: null,
        company: null,
        activate: null,
      },
      arrayCompany: null,
      valid: true,
      serviceRule: [(v) => !!v || "El campo es requerido"],
      nameRules: [(v) => !!v || "El campo es requerido"],
      fieldRules: [(v) => !!v || "El campo es requerido"],
      search: "",
      itemsCompany: [],
    };
  },
  async mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.$refs.form.reset();
        this.$emit("close");
        // Or any other way you want to close your modal
      }
    });
    // evento despues de nueva estacion
    this.$root.$on("reload", async () => {
      await this.getJsonData();
    });
    await this.getJsonData();
  },
  updated() {
    if(this.isMaster == 0) {
      this.form.company = this.itemsCompany[0];
    }
  },
  watch: {
    search: {
      handler() {
        this.getJsonData().then((data) => {
          this.itemsCompany = data.docs;
        });
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["addProfile", "alertSnackbar"]),
    validate() {
      if (this.$refs.form.validate()) {
        this.registerForm();
      }
    },
    async getJsonData() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };

          axios
            .get(`company/list?page=1&search=${this.search}`, {
              headers: headerToken,
            })
            .then((res) => {
              this.itemsCompany = res.data.docs;
              resolve(res.data);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async registerForm() {
      try {
        let newData = await this.addProfile(this.form);
        this.$refs.form.reset();
        this.show = false;
        if (newData == 200) {
          this.alertSnackbar({
            snackbar: true,
            text: "El perfil se ha creado.",
          });
          this.$root.$emit("reload"); // parametro update tabla
        }
      } catch (error) {
        this.alertSnackbar({
          snackbar: true,
          text: "ocurrio un error con el servidor.",
        });
      }
    },
  },
  computed: {
    ...mapGetters(["getListCompany","isMaster"]),
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.reset();
          this.$emit("close");
        }
      },
    },
  },
};
</script>
<style lang="scss" scope>
@import "../../assets/scss/base.scss";
</style>
